import React, { ComponentType } from 'react'
import AntdUpload from 'antd/lib/upload'
import type { UploadProps as AntdUploadProps } from 'antd/lib/upload'
import { connectReadonlyComponent } from '../connect'

import 'antd/lib/upload/style'

export * from 'antd/lib/upload'

export type UploadProps = AntdUploadProps & {
  readonly?: boolean
}

const Upload: ComponentType<UploadProps> = connectReadonlyComponent(AntdUpload, (props) => (
  <AntdUpload {...props} disabled />
))

// @ts-ignore
Upload.Dragger = AntdUpload.Dragger

export default Upload
